import { Reveal, FadeIn, SectionTag } from "@/components/Reveal";

export default function PageHeader({ index, tag, title, description }) {
  return (
    <header className="border-b border-white/10 px-6 pb-16 pt-36 md:px-12 md:pt-44 lg:px-20" data-testid="page-header">
      <SectionTag index={index} label={tag} />
      <Reveal immediate delay={0.1} className="mt-6">
        <h1 className="font-display text-5xl font-bold uppercase leading-[1.08] tracking-normal sm:text-6xl sm:leading-[1.08] lg:text-7xl lg:leading-[1.08]">
          {title}
        </h1>
      </Reveal>
      {description && (
        <FadeIn delay={0.3}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-neutral-400 md:text-lg">{description}</p>
        </FadeIn>
      )}
    </header>
  );
}
